import CreateTeam from './components/onboarding/CreateTeam';
import ManageTeam from './components/manage-team/manage-team';
import ViewOthersTeam from './components/manage-team/View-Other-Team';
import CreateTeamPlayerListingOpen from './components/onboarding/CreateTeamPlayerListingOpen.js';
import SelectCaptain from './components/onboarding/SelectCaptain';
import GetSelectBadge from './components/onboarding/GetSelectBadge';
import GetTeamName from './components/onboarding/GetTeamName';
import FavouriteClub from './components/onboarding/FavouriteClub';
import GetSaveTeam from './components/onboarding/GetSaveTeam';
import Login from './components/login';
import Home from './components/home';
import Leagues from "./components/leagues";
import CreateLeague from "./components/leagues/create-league";
import LeagueSettings from "./components/leagues/league-settings";
import LeagueLeaderBoard from "./components/leagues/leagueLeaderBoard";
import PublicLeaderBoard from "./components/leagues/publicLeaderBoard";
import Rules from "./components/rules";
import Prizes from "./components/prizes";
import Help from "./components/help";
import Achievements from "./components/achievements";
import Matches from "./components/matches";
import Endofseason from "./components/Endofseason"
import { find } from 'lodash';
import ManageTeamSummary from './components/manage-team/Manage-Team-Summary';
import UserSettings from './components/user-settings';
import MatchDetails from './components/matches/Match-Details';
import LandingPage from './components/LandingPage';
import config from './config';

const data = [
    {
        name: 'create-team',
        title: 'create-team',
        toShow: true,
        isSelected: false,
        path: '/create-team',
        group: 'create-team',
        component: CreateTeam,
        isAuthRequired: false,
        onlyWhenNoTeam: true,
        step: 0,
        order: 2,
        TrkPageTitle: 'uclfantasy create team',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game entry',
        TrkPageSubType: 'uclfantasy player selection',
    },
    {
        name: 'manage-team',
        title: 'manage-team',
        toShow: true,
        isSelected: false,
        path: '/manage-team/:matchDayID?',
        path_: '/manage-team',
        group: 'manage-team',
        component: ManageTeam,
        inMobileFooter: true,
        isAuthRequired: true,
        isTeamRequired: true,
        step: 0,
        order: 2,
        TrkPageTitle: 'Fantasy - My team (transfers or subs mode)',
        TrkPageFormat: 'standard view',
        TrkPageType: 'fantasy team',
        TrkPageSubType: 'manage my team',
    },
    {
        name: 'player-list',
        title: 'player-list',
        toShow: false,
        isSelected: false,
        path: '/player-list',
        component: CreateTeamPlayerListingOpen,
        isAuthRequired: false,
        step: 0,
        TrkPageFormat: 'standard view',
        TrkPageType: '',
        TrkPageSubType: '',
    },
    {
        name: 'select-captain',
        title: 'select-captain',
        toShow: false,
        isSelected: false,
        path: '/select-captain',
        group: 'create-team',
        component: SelectCaptain,
        isAuthRequired: false,
        step: 1,
        TrkPageTitle: 'uclfantasy select captain',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game entry',
        TrkPageSubType: 'uclfantasy captain selection',
    },
    {
        name: 'select-badge',
        title: 'select-badge',
        toShow: false,
        isSelected: false,
        path: '/select-badge',
        group: 'create-team',
        component: GetSelectBadge,
        isAuthRequired: false,
        step: 2,
        TrkPageTitle: 'UCL Fantasy - Select Badge',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game entry',
        TrkPageSubType: 'uclfantasy select team badge',
    },
    {
        name: 'team-name',
        title: 'team-name',
        toShow: false,
        isSelected: false,
        path: '/team-name',
        group: 'create-team',
        component: GetTeamName,
        isAuthRequired: false,
        step: 3,
        TrkPageTitle: 'uclfantasy enter team name',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game entry',
        TrkPageSubType: 'uclfantasy enter team name',
    },
    {
        name: 'favourite-club',
        title: 'favourite-club',
        toShow: false,
        isSelected: false,
        path: '/favourite-club',
        group: 'create-team',
        component: FavouriteClub,
        isAuthRequired: false,
        step: 4,
        TrkPageTitle: 'UCL Fantasy - Select Club League',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game entry',
        TrkPageSubType: 'fantasy select club league',
    },
    {
        name: 'save-team',
        title: 'save-team',
        toShow: false,
        isSelected: false,
        path: '/save-team',
        group: 'create-team',
        component: GetSaveTeam,
        isAuthRequired: false,
        step: 5,
        TrkPageTitle: 'uclfantasy save team',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game entry',
        TrkPageSubType: 'fantasy team summary',
    },
    {
        name: 'home',
        title: 'home',
        toShow: true,
        isSelected: false,
        path: '/',
        group: 'home',
        component: Home,
        inMobileFooter: true,
        isAuthRequired: true,
        isTeamRequired: true,
        step: 6,
        order: 1,
        TrkPageTitle: 'Fantasy - Fantasy overview',
        TrkPageFormat: 'standard view',
        TrkPageType: 'hub',
        TrkPageSubType: 'uclfantasy',
    },
    {
        path: '/login',
        component: Login,
        isAuthRequired: false,
        step: 7,
        TrkPageFormat: 'standard view',
        TrkPageType: '',
        TrkPageSubType: '',
    },
    {
        name: 'leagues',
        title: 'leagues',
        toShow: true,
        isSelected: false,
        path: '/leagues/:leagueCode?/:leagueName?/:userName?',
        path_: '/leagues',
        group: 'league',
        component: Leagues,
        inMobileFooter: true,
        isAuthRequired: false,
        isTeamRequired: false,
        step: 8,
        order: 4,
        TrkPageTitle: 'Leagues',
        TrkPageFormat: 'standard view',
        TrkPageType: 'list',
        TrkPageSubType: 'uclfantasy leagues',
    },
    {
        name: 'leagues',
        title: 'create-league',
        toShow: false,
        isSelected: false,
        path: '/create-league',
        group: 'league',
        component: CreateLeague,
        isAuthRequired: true,
        isTeamRequired: true,
        step: 8,
        order: 4,
        TrkPageTitle: 'UCL Fantasy - Create League',
        TrkPageFormat: 'standard view',
        TrkPageType: 'create league-group',
        TrkPageSubType: 'fantasy',
    },
    {
        name: 'league-leaderboard',
        title: 'league-leaderboard',
        toShow: false,
        isSelected: false,
        path: '/league-leaderboard/:leagueID',
        path_: '/league-leaderboard',
        group: 'league',
        component: LeagueLeaderBoard,
        isAuthRequired: true,
        isTeamRequired: true,
        step: 8,
        order: 4,
        TrkPageTitle: 'UCL Fantasy - League Leaderboard',
        TrkPageFormat: 'standard view',
        TrkPageType: 'leaderboard',
        TrkPageSubType: 'fantasy league',
    },
    {
        name: 'league-leaderboard',
        title: 'league-leaderboard',
        toShow: false,
        isSelected: false,
        path: '/public-leaderboard/:TypeID/:countryID/:clubID',
        path_: '/public-leaderboard',
        group: 'league',
        component: PublicLeaderBoard,
        isAuthRequired: true,
        isTeamRequired: true,
        step: 8,
        order: 4,
        TrkPageTitle: 'UCL Fantasy - Public Leaderboard',
        TrkPageFormat: 'standard view',
        TrkPageType: 'leaderboard',
        TrkPageSubType: 'fantasy league',
    },
    {
        name: 'league-settings',
        title: 'league-settings',
        toShow: false,
        isSelected: false,
        path: '/league-settings/:leagueID',
        path_: '/league-settings',
        group: 'league',
        component: LeagueSettings,
        isAuthRequired: true,
        isTeamRequired: true,
        step: 8,
        order: 4,
        TrkPageTitle: 'UCL Fantasy - League Settings',
        TrkPageFormat: 'standard view',
        TrkPageType: 'settings',
        TrkPageSubType: 'fantasy league',
    },
    {
        name: 'rules',
        title: 'rules',
        toShow: true,
        isSelected: false,
        path: '/rules',
        group: 'rules',
        component: Rules,
        isAuthRequired: false,
        isExternal: true,
        // url: 'https://www.uefa.com/news/newsid={{ARTICLE_ID}}.html',
        url: 'https://gaming.uefa.com/news/025f-0fd4b42cc0a7-74498b7df63b-1000/?mobileview={{boolean}}',
        step: 9,
        order: 6,
        TrkPageTitle: 'UCL Fantasy - Rules',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game rules',
        TrkPageSubType: 'fantasy',
    },
    {
        name: 'prizes',
        title: 'prizes',
        toShow: true,
        isSelected: false,
        path: '/prizes',
        group: 'prize',
        component: Prizes,
        isExternal: true,
        // url: 'https://www.uefa.com/news/newsid={{ARTICLE_ID}}.html',
        url: 'https://gaming.uefa.com/news/025f-0fd4b51510e8-9a324b5573e1-1000/?mobileview={{boolean}}',
        isAuthRequired: false,
        step: 10,
        order: 7,
        TrkPageTitle: 'UCL Fantasy - Prizes',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game prizes',
        TrkPageSubType: 'fantasy',
    },
    {
        name: 'help',
        title: 'help',
        toShow: false,
        isSelected: false,
        path: '/help',
        group: 'help',
        component: Help,
        isAuthRequired: false,
        step: 11,
        order: 9,
        TrkPageTitle: 'UCL Fantasy - Help',
        TrkPageFormat: 'standard view',
        TrkPageType: 'help',
        TrkPageSubType: 'fantasy',
    },
    {
        name: 'achievements',
        title: 'achievements',
        toShow: false,
        isSelected: false,
        path: '/achievements',
        group: 'achievement',
        component: Achievements,
        isAuthRequired: false,
        step: 12,
        order: 5,
        TrkPageTitle: 'UCL Fantasy - Achievements',
        TrkPageFormat: 'standard view',
        TrkPageType: 'achievements',
        TrkPageSubType: 'fantasy',
    },
    {
        name: 'matches',
        title: 'matches',
        toShow: true,
        isSelected: false,
        path: '/matches',
        group: 'match',
        component: Matches,
        inMobileFooter: true,
        isAuthRequired: false,
        step: 13,
        order: 3,
        TrkPageTitle: 'UCL Fantasy - Matches',
        TrkPageFormat: 'standard view',
        TrkPageType: 'match listing',
        TrkPageSubType: 'fantasy match calendar',
    },
    {
        name: 'transfer-summary',
        title: 'transfer-summary',
        toShow: false,
        isSelected: false,
        path: '/transfer-summary',
        component: ManageTeamSummary,
        group: 'manage-team',
        isAuthRequired: true,
        step: 14,
        TrkPageTitle: 'Fantasy - Transfers mode summary',
        TrkPageFormat: 'standard view',
        TrkPageType: 'game entry',
        TrkPageSubType: 'fantasy transfers summary',
    },
    {
        name: 'settings',
        title: 'settings',
        toShow: true,
        path: '/settings',
        component: UserSettings,
        group: 'user-settings',
        isAuthRequired: true,
        isTeamRequired: true,
        step: 15,
        order: 8,
        TrkPageTitle: 'Fantasy - Game settings',
        TrkPageFormat: 'standard view',
        TrkPageType: 'settings',
        TrkPageSubType: 'uclfantasy team name edit',
    },
    {
        name: 'view-others-team',
        title: 'view-others-team',
        toShow: false,
        isSelected: false,
        path: '/team/:GUID/:UserId/:UserTeamId/:GDID?/:PHID?',
        path_: '/',
        group: 'view-others-team',
        component: ViewOthersTeam,
        isAuthRequired: true,
        isTeamRequired: true,
        step: 16,
        order: 10,
        TrkPageTitle: 'UCL Fantasy - View Other Users Team',
        TrkPageFormat: 'standard view',
        TrkPageType: 'fantasy team',
        TrkPageSubType: 'others team view',
    },
    {
        name: 'match-details',
        title: 'match-details',
        toShow: false,
        isSelected: false,
        path: '/matchdetails/:matchId?/:status?',
        path_: '/matchdetails',
        group: 'match',
        component: MatchDetails,
        inMobileFooter: false,
        isAuthRequired: false,
        step: 17,
        order: 3,
        TrkPageTitle: 'UCL Fantasy - Match Details',
        TrkPageFormat: 'standard view',
        TrkPageType: 'as',
        TrkPageSubType: 'as',
    },
    {
        name: 'end-of-season',
        title: 'end-of-season',
        toShow: true,
        isSelected: false,
        path: '/end-of-season',
        group: 'eos',
        component: Endofseason,
        isAuthRequired: false,
        onlyWhenNoTeam: true,
        step: 0,
        order: 2,
        TrkPageTitle: 'UCL Fantasy - End of season',
        TrkPageFormat: 'standard view',
        TrkPageType: 'End of season',
        TrkPageSubType: 'End of season',
    }


    /*****************TEMPORARY CHANGE */
    // {
    //     name: 'end-of-season',
    //     title: 'end-of-season',
    //     toShow: true,
    //     isSelected: false,
    //     path: '/matches-postponed',
    //     group: 'eos',
    //     component: Endofseason,
    //     isAuthRequired: false,
    //     onlyWhenNoTeam: true,
    //     step: 0,
    //     order: 2,
    //     TrkPageTitle: 'UCL Fantasy - End of season',
    //     TrkPageFormat: 'standard view',
    //     TrkPageType: 'End of season',
    //     TrkPageSubType: 'End of season',
    // },

];

function addLandingPageClientRoute(data) {
    let landingPageClients = config.landingPageClients
    for (let c in landingPageClients) {
        let clientName = landingPageClients[c]
        let route = {
            name: clientName + '-landing',
            title: clientName + '-landing',
            toShow: false,
            isSelected: false,
            path: '/' + clientName + '-landing',
            path_: '/' + clientName + '-landing',
            group: 'landing',
            component: LandingPage,
            inMobileFooter: false,
            isAuthRequired: false,
            step: 18,
            TrkPageTitle: 'UCL Fantasy - ' + clientName + '-Landing',
            TrkPageFormat: 'standard view',
            TrkPageType: 'landing',
            TrkPageSubType: 'landing',
        }
        data.push(route)
    }
    return data;
}

export default addLandingPageClientRoute(data);

export function getStep(path) {
    path = path.split('/').filter(Boolean)[0];
    const route = find(data, route => route.path.indexOf(path) > -1);
    return route ? route.step : -1;
}


// WEBPACK FOOTER //
// ./src/route-component.js